import { lazy } from 'react';
import { TopCars } from '../../containers/FMM';

const Cards = lazy(() => import(/* webpackChunkName: 'Cards' */ '../Cards'));
const Consumption = lazy(
  () => import(/* webpackChunkName: 'Consumption' */ 'Components/Consumption')
);
const DealerPrivacy = lazy(
  () => import(/* webpackChunkName: 'DealerPrivacy' */ '../../plugins/DealerPrivacy')
);
const DealerImprint = lazy(
  () => import(/* webpackChunkName: 'DealerImprint' */ '../../plugins/DealerImprint')
);
const Imprint = lazy(() => import(/* webpackChunkName: 'Imprint' */ '../../plugins/Imprint'));
const HeroHeaderCompact = lazy(
  () => import(/* webpackChunkName: 'HeroHeaderCompact' */ '../HeroHeader/compact')
);
const HeroHeaderSmall = lazy(
  () => import(/* webpackChunkName: 'HeroHeaderSmall' */ '../HeroHeader/small')
);
const MoodImage = lazy(() => import(/* webpackChunkName: 'MoodImage' */ '../MoodImage'));
const IntroText = lazy(() => import(/* webpackChunkName: 'IntroText' */ '../IntroText'));
const Teaser = lazy(() => import(/* webpackChunkName: 'Teaser' */ '../Teaser'));
const ContentTextDeprecated = lazy(
  () => import(/* webpackChunkName: 'ContentTextDeprecated' */ '../ContentText/deprecated')
);
const ContentText = lazy(() => import(/* webpackChunkName: 'ContentText' */ '../ContentText'));
const BusinessOfferList = lazy(
  () => import(/* webpackChunkName: 'OfferList' */ '../../plugins/OfferList')
);
const ServiceOfferList = lazy(
  () => import(/* webpackChunkName: 'OfferList' */ '../../plugins/OfferList/service')
);
const Footnotes = lazy(() => import(/* webpackChunkName: 'Footnotes' */ '../../plugins/Footnotes'));
const CookieSettings = lazy(
  () => import(/* webpackChunkName: 'CookieSettings' */ '../../plugins/CookieSettings')
);
const Landingpage = lazy(
  () => import(/* webpackChunkName: 'Landingpage' */ '../../plugins/Landingpage')
);
const DealerToolboxDetails = lazy(
  () => import(/* webpackChunkName: 'DealerToolboxDetails' */ '../../plugins/DealerToolboxDetails')
);
const LinkSection = lazy(
  () => import(/* webpackChunkName: 'LinkSection' */ 'Components/LinkSection')
);
const LinkSectionLink = lazy(
  () => import(/* webpackChunkName: 'LinkSectionLink' */ 'Components/LinkSection/link')
);
const IframeSource = lazy(() => import(/* webpackChunkName: 'IframeSource' */ '../IframeSource'));
const TeamList = lazy(() => import(/* webpackChunkName: 'TeamList' */ '../../plugins/TeamList'));
const GridContentBox = lazy(
  () => import(/* webpackChunkName: 'GridContentBox' */ '../GridContentBox')
);
const CareerDetails = lazy(
  () => import(/* webpackChunkName: 'CareerDetails' */ '../../plugins/CareerDetails')
);
const CareerJobList = lazy(
  () => import(/* webpackChunkName: 'CareerJobList' */ '../../plugins/CareerJobList')
);
const Gallery = lazy(() => import(/* webpackChunkName: 'Gallery' */ '../Gallery'));

const ChessboardRenderer = lazy(
  () => import(/* webpackChunkName: 'ChessboardRenderer' */ '../Chessboard/renderer')
);
const ChessboardItem = lazy(
  () => import(/* webpackChunkName: 'ChessboardItem' */ '../Chessboard/item')
);
const Video = lazy(() => import(/* webpackChunkName: 'Video' */ '../Video'));
const ServiceDetails = lazy(
  () => import(/* webpackChunkName: 'ServiceDetails' */ '../../plugins/ServiceDetails')
);
const ServiceCategoryList = lazy(
  () => import(/* webpackChunkName: 'ServiceCategoryList' */ '../../plugins/ServiceCategoryList')
);
const AccessoriesList = lazy(
  () => import(/* webpackChunkName: 'AccessoriesList' */ '../../plugins/AccessoriesList')
);
const AccessoriesDetails = lazy(
  () => import(/* webpackChunkName: 'AccessoriesDetails' */ '../../plugins/AccessoriesDetails')
);
const AboutUs = lazy(() => import(/* webpackChunkName: 'AboutUs' */ '../../plugins/AboutUs'));
const LinkBox = lazy(() => import(/* webpackChunkName: 'LinkBox' */ 'Components/LinkBox'));
const Bentobox = lazy(() => import(/* webpackChunkName: 'Bentobox' */ 'Components/Bentobox'));

export const GENERIC_COMPONENT_MAP = {
  mask_bentobox: Bentobox,
  mask_chessboard_wcag: ChessboardRenderer,
  mask_chessboard_item_wcag: ChessboardItem,
  mask_consumption_info: Consumption,
  mask_hero_header_big: HeroHeaderCompact,
  mask_hero_header_compact_wcag: HeroHeaderCompact,
  mask_hero_header_small_wcag: HeroHeaderSmall,
  mask_mood_image: MoodImage,
  mask_intro_text_wcag: IntroText,
  mask_contentbox_3columns_wcag: GridContentBox,
  mask_link_section_wcag: LinkSection,
  mask_link_section_item_wcag: LinkSectionLink,
  mask_video: Video,
  mask_json: IframeSource,
  mask_gallery: Gallery,
  mask_teaser_area_content: Teaser,
  mask_content_text: ContentTextDeprecated,
  mask_content_text_wcag: ContentText,
  mask_content_pagelinks_wcag: LinkBox,
  plugin_mazdaapi_services_list: ServiceCategoryList,
  plugin_mazdaapi_services_detail: ServiceDetails,
  plugin_mazdaapi_career_job_list: CareerJobList,
  plugin_mazdaapi_career_job_detail: CareerDetails,
  plugin_mazdaapi_team_list: TeamList,
  plugin_mazdaapi_accessories_list: AccessoriesList,
  plugin_mazdaapi_accessories_detail: AccessoriesDetails,
  plugin_mazdaapi_aboutus: AboutUs,
  plugin_footnotes: Footnotes,
  plugin_footnotes_landingpage: Footnotes,
  plugin_mazdaapi_imprint: Imprint,
  plugin_mazdaapi_cookies: CookieSettings,
  plugin_mazdaapi_dealer_privacy: DealerPrivacy,
  plugin_mazdaapi_dealer_imprint: DealerImprint,
  mask_landingpage_business_offers: Landingpage,
  mask_landingpage_business_offers_highlight_offers: BusinessOfferList, // Vertriebsangebote
  mask_landingpage_service_offers: Landingpage,
  mask_landingpage_service_offers_highlight_offers: ServiceOfferList, // Elite Serviceangebote
  plugin_mazdaapi_dealertoolbox_detail: DealerToolboxDetails,
  mask_plugin_entrypage_subsites: Cards,
  mask_plugin_entrypage_showroom: Cards,
  mask_plugin_fmm_topcars: TopCars,
};

export const GENERIC_TYPES_TO_WRAP = {
  mask_link_section_item: 'mask_link_section',
  mask_link_section_item_wcag: 'mask_link_section_wcag',
  mask_chessboard_item: 'mask_chessboard',
  mask_chessboard_item_wcag: 'mask_chessboard_wcag',
};
